type Handler = (payload: unknown) => void;

export class EventBus<M extends Record<string, unknown>> {
  private readonly listeners = new Map<keyof M, Set<Handler>>();

  on<K extends keyof M>(event: K, fn: (payload: M[K]) => void): () => void {
    const set = this.listeners.get(event) ?? new Set<Handler>();
    set.add(fn as Handler);
    this.listeners.set(event, set);
    return () => set.delete(fn as Handler);
  }

  emit<K extends keyof M>(event: K, payload: M[K]): void {
    this.listeners.get(event)?.forEach(fn => {
      fn(payload);
    });
  }
}

export type AppEventMap = {
  'user:logout': { reason: 'manual' | 'expired' };
  'navigation:notfound': undefined;
};

export const appEvents = new EventBus<AppEventMap>();
